import type { IconData } from '@stacksjs/iconify-core'

export const micF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M12 12H8a1 1 0 0 0 0 2h3.659a6.02 6.02 0 0 1-3.686 3.668a2 2 0 1 1-3.945 0A6.02 6.02 0 0 1 .34 14H4a1 1 0 0 0 0-2H0v-2h4a1 1 0 1 0 0-2H0V6h4a1 1 0 1 0 0-2H.341A6.002 6.002 0 0 1 11.66 4H8a1 1 0 1 0 0 2h4v2H8a1 1 0 1 0 0 2h4z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default micF
